<style xmlns="http://www.w3.org/1999/html">
    .header-home-nav, .home-footer {
        background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
        padding-bottom: 10px;
    }

</style>

<template>
    <div>
        <div class="container-fluid blue-letters-girl">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Годовой курс английского языка
                        </div>

                        <h1 class="desktop-vers">Годовой курс <span class="yellow-span">английского языка</span></h1>
                        <h1 class="mobile-vers">Годовой курс<br> <span class="yellow-span">английского языка</span></h1>

                        <h3>для детей от 3 до 12 лет</h3>
                        <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                                src="~@/assets/hometeacher/images/girl-notik.jpg" alt="Годовой курс английского языка"
                                class="mobile girl-notik"></div>
                        <p>Индивидуальное обучение с помощью интерактивных видеоуроков с личным преподавателем-наставником.</p>
                      <p><span class="strong-black">Годовой курс включает в себя:</span></p>
                      <div class="chek" style="margin-right: 10px;"></div>
                      <p><span class="strong-black">72 интерактивных видеоурока, направленных на развитие навыков говорения, изучения лексики и получения удовольствия от изучения английского языка.</span></p>
                      <p>Ребенок занимается в удобное время на любом устройстве с выходом в интернет на интерактивной платформе.
                        Каждое занятие содержит физкультминутку и гимнастику для глаз. Ребенок последовательно проходит интерактивные видеоуроки,
                        проверяет знания с помощью тестов, и получает поддержку преподавателя-наставника.</p>
                        <p class="desktop-vers"><span class="blue-fon-text">С нами дети развиваются, интересно проводят время, обучаясь английскому</span>
                            <br>
                            <span class="blue-fon-text">как второму родному языку.</span></p>

                        <p class="mobile-vers"><span class="blue-fon-text">С нами дети развиваются,</span><br>
                            <span class="blue-fon-text">интересно проводят время,</span><br>
                            <span class="blue-fon-text">обучаясь английскому как</span><br>
                            <span class="blue-fon-text">второму родному языку.</span></p>

                    </div>
                </div>
              <div class="row" style="text-align: center; max-width: 865px;">
                <div class="col-12 col-sm-6">
                  <div class="knpk"><a href="https://poliglotiki.com/home-teacher/course/anglijskij-dlya-doshkolnikov-nachinayushchie/details">Купить Курс для начинающих</a></div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="knpk"><a href="https://poliglotiki.com/home-teacher/course/anglijskij-dlya-doshkolnikov-prodolzhayushchie/details">Купить Курс для продолжающих</a></div>
                </div>
              </div>
            </div>
        </div>

        <div class="container-fluid vkurs">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check">
                        <label for="check"><h2 class="iba">Курс "Английский для детей"</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <img src="~@/assets/hometeacher/images/girl-wow.jpg" alt="Годовой курс английского языка">
                            <div>
                                <p style="font-size: 3px;">&nbsp;</p>

                              <div class="chek"></div>
                              <p><span class="strong-black">72 творческих задания</span>. Дополнительные интерактивные уроки, направленные на развитие творческих навыков и закрепление лексики</p>
                              <div class="chek"></div>
                              <p><span class="strong-black">144 тренажера</span> для проверки знаний и повторения</p>
                              <div class="chek"></div>
                              <p><span class="strong-black">150 рабочих листов</span></p>
                              <div class="chek"></div>
                              <p><span class="strong-black">10 консультаций с наставником</span> для проведения диагностики, оценки результата и составления индивидуального плана развития</p>
                              <div class="chek"></div>
                              <p><span class="strong-black">40 занятий</span> «Английский через музыку»</p>
                              <div class="chek"></div>
                              <p><span class="strong-black">Неограниченный доступ</span> к групповым занятиям (в группах до 10 детей)</p>
                              <p style="font-size: 3px;">&nbsp;</p>

                              <div class="red-chek"></div>
                              <p class="bezlimit-group" style="background-image: none;"><span class="strong-black"><a href="https://poliglotiki.com/home-teacher/schedule/lang/en">Безлимитные групповые онлайн-занятия</a> по расписанию с преподавателем</span>
                                в качестве факультативных предметов на английском языке: Story Time, Art Class, Music Class.</p>
                              <div class="knpk-blue"><a href="https://poliglotiki.com/home-teacher/schedule">Посмотреть расписание</a></div>
                              <p>Ребенок обучается самостоятельно, родителям не нужно присутствовать на занятии.</p>
                              <p>Дети учат английский через игру, все занятия проходят полностью на английском языке, ребенок полностью погружается в языковую среду и уже с первого урока начинает говорить на английском! Творческие задания, песни, игры, поделки, онлайн-тесты и тренажеры – все мотивирует детей! Занятия на платформе станут для ребенка любимым предметом.</p>
                              <p>А если хочется еще больше английского? Дополнительно можно приобрести индивидуальные онлайн-занятия с преподавателем.</p>
                              <div class="red-chek"></div>
                              <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">Индивидуальные занятия проводятся по персональному расписанию минимум 2 раза в неделю.</span>
                              </p>
                              <div class="knpk-blue" style="max-width: 375px;"><a href="https://poliglotiki.com/home-teacher/individual">Записаться на индивидуальные занятия</a></div>


                            </div>
                            <h3>Длительность всего курса: 1 год. </h3>
                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2 class="iba desktop-vers">Курс "Английский для детей"</h2>

                        <img src="~@/assets/hometeacher/images/girl-wow.jpg" alt="Годовой курс английского языка">

                        <p style="font-size: 3px;">&nbsp;</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">72 творческих задания</span>. Дополнительные интерактивные уроки, направленные на развитие творческих навыков и закрепление лексики</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">144 тренажера</span> для проверки знаний и повторения</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">150 рабочих листов</span></p>
                        <div class="chek"></div>
                        <p><span class="strong-black">10 консультаций с наставником</span> для проведения диагностики, оценки результата и составления индивидуального плана развития</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">40 занятий</span> «Английский через музыку»</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">Неограниченный доступ</span> к групповым занятиям (в группах до 10 детей)</p>
                        <p style="font-size: 3px;">&nbsp;</p>

                        <div class="red-chek"></div>
                        <p class="bezlimit-group" style="background-image: none;"><span class="strong-black"><a href="https://poliglotiki.com/home-teacher/schedule/lang/en">Безлимитные групповые онлайн-занятия</a> по расписанию с преподавателем</span>
                        в качестве факультативных предметов на английском языке: Story Time, Art Class, Music Class.</p>
                        <div class="knpk-blue"><a href="https://poliglotiki.com/home-teacher/schedule">Посмотреть расписание</a></div>
                        <p>Ребенок обучается самостоятельно, родителям не нужно присутствовать на занятии.</p>
                        <p>Дети учат английский через игру, все занятия проходят полностью на английском языке, ребенок полностью погружается в языковую среду и уже с первого урока начинает говорить на английском! Творческие задания, песни, игры, поделки, онлайн-тесты и тренажеры – все мотивирует детей! Занятия на платформе станут для ребенка любимым предметом.</p>
                        <p>А если хочется еще больше английского? Дополнительно можно приобрести индивидуальные онлайн-занятия с преподавателем.</p>
                        <div class="red-chek"></div>
                        <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">Индивидуальные занятия проводятся по персональному расписанию минимум 2 раза в неделю.</span>
                        </p>
                      <div class="knpk-blue" style="max-width: 375px;"><a href="https://poliglotiki.com/home-teacher/individual">Записаться на индивидуальные занятия</a></div>


                        <h3>Длительность всего курса: 1 год. </h3>
                    </div>

                </div>
       <!--         <div class="row">
                  <div class="col-12">
                    <div class="land-t-delimeter" style="margin-bottom: 50px;"></div>
                  </div>
                </div>
              <div class="row">
                <div class="col-12">
                  <h2 class="iba">Через год Ваш ребенок:</h2>

                  <div class="chek"></div>
                  <p><span class="strong-black">Может рассказать</span> истории и поддержать диалог на 25 различных тем</p>
                  <div class="chek"></div>
                  <p><span class="strong-black">Понимает речь</span> на английском</p>
                  <div class="chek"></div>
                  <p><span class="strong-black">Говорит на английском</span> с хорошим акцентом</p>
                  <div class="chek"></div>
                  <p><span class="strong-black">Знает</span> более 40 песен</p>
                  <div class="chek"></div>
                  <p>Словарная база &ndash; <span class="strong-black">более 300 слов</span></p>
                  <div class="chek"></div>
                  <p><span class="strong-black">Умеет грамотно</span> строить предложения и давать развернутые ответы на вопросы</p>
                  <div class="chek"></div>
                  <p><span class="strong-black">Получает удовольствие</span> от общения на английском языке</p>

                  <p>За каждый пройденный тест ребенок <span class="strong-black">получает зернышки</span>, которыми он кормит птичек Поли и Глотика.
                    После прохождения годового курса зернышки можно <span class="strong-black">поменять на подарок.</span>
                    Это отличная <span class="strong-black">мотивация</span> для маленьких полиглотиков.</p>

                </div>
              </div> -->
            </div>
        </div>
        <div class="container-fluid skytop"></div>
        <div class="container-fluid skyfon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками”<br> учить английский язык — <br>
                            <span class="veselo">весело и интересно!</span></h2>
                        <p>На пробном онлайн-занятии преподаватель проводит диагностику, подбирает уровень курса,
                            составляет план развития ученика.
                            Пробное занятие открывает один урок-эпизод курса и тренажеры к нему.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid skydown"></div>

        <div class="container-fluid blue-letters-back">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabonement">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />
              <div class="row">
                <div class="col-12 col-sm-3">
                  <div class="rezults mt-lg-5 mt-0 mb-lg-0 mb-4">
                    <span class="strong-black">Через 1 месяц Ваш ребенок:</span>
                    <ul>
                      <li>Может поддержать диалог на 2 изученные темы</li>
                      <li>Понимает английскую речь по пройденным материалам</li>
                      <li>Умеет произносить простые фразы на английском</li>
                      <li>Знает 1-2 песни</li>
                      <li>Словарная база &ndash; более 25 слов</li>
                    </ul>
                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="rezults mt-lg-5 mt-0 mb-lg-0 mb-4">
                    <span class="strong-black">Через 3 месяца Ваш ребенок:</span>
                    <ul>
                      <li>Может поддержать диалог на 5 изученных тем</li>
                      <li>Понимает английскую речь по пройденным материалам</li>
                      <li>Начинает приемлемо говорить на английском</li>
                      <li>Знает более 6 песен</li>
                      <li>Словарная база &ndash; более 80 слов</li>
                      <li>Получает удовольствие от общения на английском языке</li>
                    </ul>

                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="rezults mt-lg-5 mt-0 mb-lg-0 mb-4">
                    <span class="strong-black">Через 6 месяцев Ваш ребенок:</span>
                    <ul>
                      <li>Может кратко описать увиденное и поддержать диалог на 12 различных тем</li>
                      <li>Понимает английскую речь</li>
                      <li>Говорит на английском без акцента</li>
                      <li>Знает более 15 песен</li>
                      <li>Словарная база &ndash; более 180 слов</li>
                      <li>Умеет давать развернутые ответы на вопросы</li>
                      <li>Получает удовольствие от общения на английском языке</li>
                    </ul>

                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="rezults mt-lg-5 mt-0 mb-lg-0 mb-4">
                    <span class="strong-black">Через год Ваш ребенок:</span>
                    <ul>
                      <li>Может рассказать истории и поддержать диалог на 25 различных тем</li>
                      <li>Понимает речь на английском</li>
                      <li>Говорит на английском без акцента</li>
                      <li>Знает более 40 песен</li>
                      <li>Словарная база &ndash; более 300 слов</li>
                      <li>Умеет грамотно строить предложения и давать развернутые ответы на вопросы</li>
                      <li>Получает удовольствие от общения на английском языке</li>
                    </ul>

                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-12">
                  <p style="font-size: 20px; color:#000; margin-top: 40px;">За каждый пройденный тест ребенок <span class="strong-black">получает зернышки</span>, которыми он кормит птичек Поли и Глотика.
                    После прохождения годового курса зернышки можно <span class="strong-red">поменять на подарок.</span>
                    Это отличная <span class="strong-black">мотивация</span> для маленьких полиглотиков.</p>
                </div>

              </div>
            </div>
        </div>

        <!--<div class="container-fluid align-middle getpresent">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="desktop-vers">При покупке курса <span class="toget">вы получаете в подарок:</span>
                        </h3>
                        <h3 class="mob">При покупке курсы <br>
                            <div class="toget">вы получаете в<br> подарок 5 курсов:</div>
                        </h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <StudyProductCourseList
                                :courses="courses"
                                @about="aboutCourse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div> -->
        <div class="container-fluid obuchenie">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check1">
                        <label for="check1"><h2 class="iba">Как проходит обучение</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight1"></div>
                                    <div class="bluekrug">1</div>
                                    <p>В течение недели весь учебный год ребенок получает <span class="strong-black">по 2 урока-эпизода.</span>
                                    </p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">2</div>
                                    <p><span class="strong-black">Распечатывает</span> скаченные PDF-материалы.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">3</div>
                                    <p>Всю неделю <span class="strong-black">изучает</span> темы из уроков-эпизодов.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">4</div>
                                    <p><span class="strong-black">Выполняет домашние задания</span> в формате онлайн-игр
                                        и онлайн-тренажеров.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug" style="margin-bottom: 65px;">5</div>
                                    <p>В конце месяца <span
                                            class="strong-black">встречается с персональным наставником</span> онлайн
                                        для контроля достижения результатов.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">6</div>
                                    <p><span class="strong-black">Постоянная поддержка 7/24.</span> Чат с
                                        преподавателем-наставником для любых вопросов.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Как проходит обучение</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight1"></div>
                        <div class="bluekrug">1</div>
                        <p>В течение недели весь учебный год ребенок получает <span class="strong-black">по 2 урока-эпизода.</span>
                        </p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">2</div>
                        <p><span class="strong-black">Распечатывает</span> скаченные PDF-материалы.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">3</div>
                        <p>Всю неделю <span class="strong-black">изучает</span> темы из уроков-эпизодов.</p>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-9">
                        <img src="~@/assets/hometeacher/images/strelka-krivaya.png" class="strelka-krivaya">
                    </div>

                    <div class="col-12 col-sm-3">
                        <img src="~@/assets/hometeacher/images/hello.png" class="hello">
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">4</div>
                        <p><span class="strong-black">Выполняет домашние задания</span> в формате онлайн-игр и
                            онлайн-тренажеров.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">5</div>
                        <p>В конце месяца <span class="strong-black">встречается с персональным наставником</span>
                            онлайн для контроля достижения результатов.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">6</div>
                        <p><span class="strong-black">Постоянная поддержка 7/24.</span> Чат с преподавателем-наставником
                            для любых вопросов.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>
        <div class="container-fluid white-bg no-shadow sm-video" style="padding-top: 0px;">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 style="margin-top: 40px; line-height: 1.3;">По окончании обучения<br>
                            <span class="sertifikat">ребенок получает сертификат</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:4}}">

                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/sertifikat-1.jpg">
                            </div>
                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/sertifikat-2.jpg">
                            </div>
                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/sertifikat-3.jpg">
                            </div>
                            <div class="centers-text mx-3">
                                <img src="@/assets/hometeacher/images/sertifikat-4.jpg">
                            </div>

                        </carousel>
                    </div>
                </div>
                <!--     <div class="row mobile-vers">
                       <div class="col-12">
                         <input type="checkbox" id="check2">

                         <label for="check2"><h2 class="iba">По окончании обучения<br>
                           <div class="sertifikat">ребенок<br> получает<br> сертификат</div></h2>
                           </label>
                         <img src="~@/assets/hometeacher/images/galocka.png" class="galocka">
                         <div class="block">

                               <carousel :responsive="{0:{items:1},1000:{items:4}}">

                                 <div class="centers-text mx-3">
                                   <img src="@/assets/hometeacher/images/sertifikat-1.jpg">
                                 </div>
                                 <div class="centers-text mx-3">
                                   <img src="@/assets/hometeacher/images/sertifikat-2.jpg">
                                 </div>
                                 <div class="centers-text mx-3">
                                   <img src="@/assets/hometeacher/images/sertifikat-3.jpg">
                                 </div>
                                 <div class="centers-text mx-3">
                                   <img src="@/assets/hometeacher/images/sertifikat-4.jpg">
                                 </div>

                               </carousel>
                             </div>
                           </div>
                         </div>
             -->
            </div>
        </div>

        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Смотрите видео о наших курсах</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:3}}">

                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/WGC1IQ_72B4" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Представление курса Preschool</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/J7b7sGc0tQw" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Представление курса Preschool 2</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/pdwiux-tCsQ" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Preschool Level 2. Unit 1. Lesson 2</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/w0GU0M7YdSQ" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Preschool. Unit 1. Поделки</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/pdwiux-tCsQ" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Preschool Level 2. Unit 1. Lesson 2</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/MSClV_-k-dk" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Preschool. Unit 1. Lesson 7</p>
                            </div>

                        </carousel>
                    </div>
                </div>


                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check3">
                        <label for="check3"><h2>Смотрите видео о наших курсах</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">

                            <carousel :responsive="{0:{items:1},1000:{items:3}}">

                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/WGC1IQ_72B4" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Представление курса Preschool</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/J7b7sGc0tQw" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Представление курса Preschool 2</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/pdwiux-tCsQ" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Preschool Level 2. Unit 1. Lesson 2</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/w0GU0M7YdSQ" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Preschool. Unit 1. Поделки</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/pdwiux-tCsQ" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Preschool Level 2. Unit 1. Lesson 2</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/MSClV_-k-dk" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Preschool. Unit 1. Lesson 7</p>
                                </div>

                            </carousel>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 class="otzivh2">Отзывы родителей</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:2}}">

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                                <span class="nameotzyv">Елена Серебрякова</span>
                                <div class="text-otziv">Был приобретен курс Preschool Level 1 для ребенка 5 лет.
                                    Программа работает сразу после оплаты. Замечательные занятия с понятным
                                    содержанием...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/tatyana-tumanova.jpg">
                                <span class="nameotzyv">Татьяна Туманова</span>
                                <div class="text-otziv">Отличный курс. Ребёнку очень нравится. Все понятно и доступно.
                                    Приятные преподаватели
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/no-avatar-1.png">
                                <span class="nameotzyv">Марина</span>
                                <div class="text-otziv">Посоветовал этот курс педагог в языковом центре Полиглотики,
                                    чтобы закрепить песенный материал, который изучали на занятии, развить чувство ритма
                                    и расширить...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                                <span class="nameotzyv">Елена Серебрякова</span>
                                <div class="text-otziv">Курс полезный, особенно, малышам которые занимаются в
                                    Полиглотиках он-лайн и на очных занятиях. Так как он является словарной базой для
                                    занятий, детей по ним обучают...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/no-avatar-2.png">
                                <span class="nameotzyv">Марина</span>
                                <div class="text-otziv">Курс с флеш-карточками помог нам выучить дополнительные слова на
                                    английском, значительно расширить словарный запас с минимумом усилий. Как маме мне
                                    было очень интересно...
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
                <div class="row" style="margin-top: 70px; margin-bottom: 50px;">
                    <div class="col-12" style="text-align: center;">
                        <a href="/all-comments.html" class="allotzv">Читать все отзывы</a>
                    </div>
                </div>

            <div class="row">
              <div class="col-12">
                <h2>Результаты детей через месяц после начала обучения</h2>

                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidok"
                        src="https://www.poliglotiki.ru/embed/WRPZaZbl6ss" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div></div>
          </div>
        </div>



        <div class="container-fluid skytop"></div>
        <div class="container-fluid skyfon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками”<br> учить английский язык — <br>
                            <span class="veselo">весело и интересно!</span></h2>
                        <p>На пробном онлайн-занятии преподаватель проводит диагностику, подбирает уровень курса,
                            составляет план развития ученика.
                            Пробное занятие открывает один урок-эпизод курса и тренажеры к нему.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid skydown-white desktop-vers"></div>
        <div class="container-fluid skydown mobile-vers"></div>
        <div class="container-fluid last-stav">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabon-last">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>

        <Entry/>

    </div>


</template>

<script>
    import carousel from "vue-owl-carousel";
    import moment from 'moment';
    import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
    import studyProductApi from "../data/StudyProductApi";
    import StudyProductCourseList from "./Study/landing/StudyProductCourseList";
    import Entry from "./Entry";
    import courseApi from "../data/CourseApi";

    export default {
        components: {
            StudyProductCourseList,
            StudyProductSubscriptionList,
            carousel,
            Entry,
        },
        name: "GodovojKursAnglijskogo",

        data: function () {
            return {
                title: null,
                slug: 'godovoj-kurs-anglijskogo-yazyka',
                subscriptions: [],
                freeSubscription: null,
                promoSuscription: null,
                courses: [],
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                    this.courses = response.courses

                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            /*courseApi.fetchCourseBySlug('anglijskij-dlya-doshkolnikov-nachinayushchie')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            courseApi.fetchCourseBySlug('anglijskij-dlya-doshkolnikov-prodolzhayushchie')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })*/
        },

        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
            aboutCourse(course) {
                this.$router.push('/course/' + course.slug + '/details')
            },
            tryFree() {
                if (this.freeSubscription) {
                    this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
                }
            }
        },

        metaInfo() {
            return {
                title: 'Годовой курс Английского языка',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Годовой курс Английского языка для детей от 12 месяцев до 12 лет.'
                    }
                ]
            }
        },
    }
</script>

<style scoped>

    .blue-letters-girl {
        background: url(~@/assets/hometeacher/images/blue-letters-girl.jpg) no-repeat center;
        text-align: left;
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 10px;
        min-height: 878px;
    }

    .breadcrumbs {
        font-size: 14px;
        background: #fff;
        max-width: 295px;
        padding-left: 7px;
        border-radius: 10px;
        margin-left: -7px;
    }

    .blue-letters-girl h1 {
        font-size: 50px;
        font-family: Manrope Black;
        margin-top: 15px;
        margin-bottom: 0px;
        color: #000;
        background: url(~@/assets/hometeacher/images/yellow-span.png) no-repeat right center;
        max-width: 822px;
        padding-top: 2px;
    }

    .blue-letters-girl h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        margin-bottom: 20px;
        color: #000;
    }

    .blue-letters-girl p {
        font-size: 20px;
        max-width: 800px;
       line-height: 1.5;
    }

    .blue-fon-text {
        background: #00b4f1;
        color: #fff;
        border-radius: 15px;
        padding: 2px 10px;
        font-size: 19px;
        font-family: 'Manrope Book';
        margin-left: 0px;
        line-height: 1.9;
    }

    .knpk {
        border-radius: 35px;
        max-width: 360px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 18px;
        color: #fff;
        padding: 15px 20px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
        margin-top: 35px;
    }

    .knpk:hover {
        background: #49d92c;
    }

    .knpk a, .knpk-blue a {
        color: #fff;
    }
    .knpk-blue{
      border-radius: 20px;
      max-width: 245px;
      font-family: Manrope Bold Alt;
      background: -webkit-gradient(linear, left bottom, left top, from(#00a6f2), to(#00c7ff));
      font-size: 16px;
      color: #fff;
      padding: 10px 20px;
      box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
      text-decoration: none;
      text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
      margin: -10px auto 30px auto;
      text-align: center;
    }

    .knpk-blue:hover {
      background: #00c7ff;
    }

    .vkurs {
        padding-top: 60px;
    }

    .vkurs h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 30px;
    }

    .iba {font-size: 35px !important;}

    .vkurs h3 {
        font-size: 25px;
        font-family: "Manrope Bold";
        color: #231c37;
        margin-top: 30px;
    }

    .vkurs img {
        float: right;
        margin-right: -35px;
        margin-left: 30px;
      margin-bottom: 10px;
    }

    .vkurs p {
        font-size: 20px;
        margin-left: 35px;
        line-height: 1.4;
        color: #000;
        /*max-width: 635px;*/
    }

    .leftp {
        margin-left: 0px !important;
    }

    .red-chek {
        background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .bezlimit-group {
        background-image: url(~@/assets/hometeacher/images/bezlimit-group.png);
        line-height: 1.6 !important;
        padding-left: 8px;
        padding-bottom: 3px;
        padding-right: 8px;
        /*max-width: 589px !important;*/
    }

    .onlain-kons {
        background-image: url(~@/assets/hometeacher/images/onlain-kons.png);
        line-height: 1.4 !important;
        padding-left: 8px;
        padding-bottom: 0px;
        padding-right: 8px;
        max-width: 654px !important;
        padding-top: 2px;
    }

    .chek {
        background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .skytop {
        background: url(~@/assets/hometeacher/images/sky-top.png) repeat center;
        width: 100%;
        height: 93px;
        margin-top: 50px;
    }

    .skydown {
        background: url(~@/assets/hometeacher/images/sky-down.png) repeat center;
        width: 100%;
        height: 100px;
    }

    .skydown-white {
        background: url(~@/assets/hometeacher/images/skydown-white.png) repeat center;
        width: 100%;
        height: 94px;
    }

    .skyfon {
        background: #00b4f1;
        min-height: 350px;
        overflow: hidden;
        padding-bottom: 30px;
        padding-top: 30px;
    }

    .skyfon img {
        float: right;
        margin-right: -415px;
        margin-top: 107px;
        height: 33px;
        max-width: 100%;
    }

    .skyfon h2 {
        font-family: Manrope Bold Alt;
        font-size: 40px;
        color: #fff;
        margin-top: 50px;
        line-height: 1.3;
    }

    .skyfon p {
        color: #fff;
        font-size: 18px;
        line-height: 1.4;
        margin-top: 20px;
    }

    .veselo {
        background-image: url(~@/assets/hometeacher/images/veselo-interes.png);
        padding-left: 8px;
        padding-top: 2px;
        padding-bottom: 8px;
        color: #000;
        padding-right: 8px;
    }

    .knpk-yellow {
        border-radius: 35px;
        text-align: center;
        max-width: 390px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
        font-size: 24px;
        padding: 15px 30px;
        -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        margin-top: 90px;
    }

    .knpk-yellow:hover {
        background: #fbfe00;
    }

    .knpk-yellow a {
        color: #000;
    }

    .blue-letters-back {
        background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
        margin-top: 0;
        padding-bottom: 100px;
        text-align: left;
        padding-top: 70px;
    }

    .blue-letters-back h2 {
        font-size: 40px;
        font-family: "Manrope Black";
        color: #262239;
    }

    .viborabonement {
        background-image: url(~@/assets/hometeacher/images/viborabonement.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .abonement {
        max-width: 254px;
        min-height: 233px;
        border: 1px solid #d9e0e4;
        background: #fff;
        text-align: center;
        margin-top: 50px;
        border-radius: 10px;
        box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
    }

    .month-1, .month-3, .month-6, .month-12 {
        font-size: 22px;
        text-align: center;
        font-family: "Manrope Bold Alt";
        margin-bottom: 15px;
    }

    .month-1 {
        background: url(~@/assets/hometeacher/images/month-1.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-3 {
        background: url(~@/assets/hometeacher/images/month-3.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-6 {
        background: url(~@/assets/hometeacher/images/month-6.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-12 {
        background: url(~@/assets/hometeacher/images/month-12.png) no-repeat center;
        margin-top: 4px;
        color: #fff;
    }

    .price {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #72717d;
    }

    .rubls {
        font-size: 18px;
    }

    .econom {
        font-size: 15px;
        color: #231c37;
        margin-bottom: 17px;
        margin-top: -6px;
        text-shadow: 0px 0px 0px rgb(0 0 0);
        font-weight: bold;
    }

    .all-course {
        color: #ed1c24;
        font-family: "Manrope Black";
        font-size: 18px;
    }

    .abonement a {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;
        color: #fff;
        padding: 14px 35px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
    }

    .abonement a:hover {
        background: #49d92c;
    }
    .rezults{
      max-width: 254px;
      padding-top: 10px;
      padding-right: 5px;
      min-height: 346px;
      border: 1px solid #d9e0e4;
      background: #fff;
      text-align: center;
      margin-top: 10px !important;
      border-radius: 10px;
      -webkit-box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
      box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
    }
    .rezults ul{
      text-align: left;
      font-size: 14px;
      list-style: none;
      color: #000;
      margin-left: -26px;
      margin-top: 5px;
    }

    .rezults ul li:before {
      content: "●";
      color: #ed1c24;
      display: inline-block;
      width: 1em;
    }
    .getpresent {
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 100px;
    }

    .getpresent h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 40px;
    }
    .vidok {width:100%; height: 623px;}
    .toget {
        background-image: url(~@/assets/hometeacher/images/toget.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 10px;
        padding-right: 8px;
    }

    .bigwavetop {
        background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
        width: 100%;
        height: 190px;
    }


    .obuchenie {
        padding-top: 100px;
        padding-bottom: 60px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .obuchenie h2, .sm-video h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 60px;
    }

    .obuchenie p {
        font-size: 18px;
        width: 270px;
        line-height: 1.4;
    }

    .strela {
        background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px;
        height: 19px;
        margin-top: 20px;
        left: 100px;
        position: absolute;
    }

    .bluekrug {
        width: 60px;
        height: 60px;
        border: 3px solid #00b4f1;
        border-radius: 50%;
        text-align: center;
        color: #4f4d5c;
        background: #fff;
        padding-top: 10px;
        font-size: 24px;
        font-family: "Manrope Bold";
        margin-bottom: 20px;
        position: relative;
        z-index: 10;
    }

    .strelka-krivaya {
        margin-left: 35px;
        margin-top: -40px;
        padding-bottom: 5px;
        max-width: 100%;
    }

    .hello {
        position: absolute;
        top: -150px;
        left: -20px
    }

    .sertifikat {
        background-image: url(~@/assets/hometeacher/images/sertifikat.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .sm-video {
        padding-top: 80px;
    }

    .sm-video p {
        margin-top: -100px;
        font-size: 18px;
        font-family: 'Manrope Book';
        color: #000;
        text-align: center;
    }

    .vidos {
        width: 100%;
        height: 192px;
        border-radius: 15px;
        margin-right: 0 !important;
        margin-bottom: 100px !important;
    }

    .otzivh2 {
        font-size: 36px !important;
        font-family: "Manrope Black" !important;
        color: #231c37 !important;
        margin-bottom: 60px !important;
    }

    .indotz {
        float: left;
        margin-right: 20px;
    }

    .nameotzyv {
        font-size: 21px;
        font-family: Manrope Bold;
        display: block;
        color: #000;
    }

    .text-otziv {
        font-size: 17px;
        color: #000;
        line-height: 1.4;
        margin-top: 10px;
    }

    .centers-text {
        max-width: 500px;
    }

    .allotzv {
        color: #0493c3;
        font-size: 20px;
        font-family: "Manrope Bold";
        padding: 15px 30px;
        border: 2px solid #0493c3;
        border-radius: 30px;
    }

    .allotzv:hover {
        background: #0493c3;
        color: #fff;
    }

    .viborabon-last {
        background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .last-stav {
        padding-top: 70px;
        padding-bottom: 120px;
    }

    .last-stav h2 {
        font-size: 40px;
        font-family: "Manrope Bold Alt";
        color: #262239;
    }

    .girl-notik {
        margin-left: -25px;
        margin-bottom: 20px;
        max-width: 110%;
    }

    .liniya {
        background-image: url(~@/assets/hometeacher/images/liniya.png);
        width: 100%;
        height: 36px;
        margin-top: 30px;
    }

    @media (max-width: 1199px) {
        .obuchenie {
            overflow: hidden;
        }

        .hello {
            top: -110px;
            left: -115px;
        }
    }

    @media (max-width: 991px) {
        .abonement a {
            padding: 10px;
        }
      .vidok {height: 395px;}
        .centers-text {
            max-width: 100%;
            text-align: center;
        }

        .vidos {
            height: 370px;
        }

        .indotz {
            float: none;
            margin-bottom: 20px;
        }

        .blue-letters-girl h1 {
            background: none;
        }

        .bezlimit-group, .onlain-kons {
            background: none;
        }

        .obuchenie p {
            width: 100%;
        }

        .strela {
            display: none;
        }

        .hello {
            top: -160px;
        }
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        cursor: pointer;
        color: #fff;
        text-decoration: underline;
        -moz-user-select: -moz-none;
        -webkit-user-select: none;
        user-select: none;
    }

    .block {
        width: 100%;
        display: none;
    }

    input:checked ~ .block {
        display: block;
    }

    .galocka {
        margin-right: 0px !important;
        margin-top: -110px;
        float: right !important;
    }
    @media (max-width: 750px) {
      .vidok {height: 295px;}
    }
    @media (max-width: 575px) {
        .blue-letters-girl {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-bottom: 60px;
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
        }

        .blue-letters-girl h1 {
            font-size: 40px;
            line-height: 1.1;
        }

        .blue-letters-girl h3 {
            font-size: 22px;
            margin-top: 10px;
        }

        .yellow-span {
            background-image: url(~@/assets/hometeacher/images/yellow-span-mob.png);
            font-size: 30px;
            padding-left: 8px;
            padding-top: 2px;
            padding-bottom: 3px;
            padding-right: 11px;
        }

        .vkurs {
            padding-left: 15px !important;
            padding-right: 15px !important;
            box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);
        }

        .vkurs h2 {
            font-size: 33px;
        }

        .vkurs img {
            float: none;
            max-width: 80%;
            margin-right: 0px !important;
        }

        .skyfon, .blue-letters-back {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .skyfon h2 {
            font-size: 25px;
            line-height: 1.5;
        }

        .skyfon img {
            display: none;
        }

        .skytop {
            margin-top: 0px;
        }

        .veselo {
            background-image: url(~@/assets/hometeacher/images/veselo-interes-mob.png);
            padding-left: 8px;
            padding-top: 4px;
            padding-bottom: 10px;
            color: #000;
            padding-right: 13px;
        }

        .knpk-yellow {
            margin-top: 40px;
            font-size: 20px;
            padding: 15px;
        }

        .blue-letters-back h2, .last-stav h2 {
            font-size: 33px;
            text-align: center;
        }

        .viborabonement {
            background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
            width: 240px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 2px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .abonement {
            margin: 0 auto;
            margin-bottom: 30px;
        }

        .abonement a {
            padding: 15px 35px;
        }

        .getpresent {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 60px;
            text-align: center;
        }

        .toget {
            background-image: url(~@/assets/hometeacher/images/toget-mob.png);
            text-align: left;
            width: 285px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 10px;
            margin-bottom: 30px;
            margin-top: -10px;
        }


        .obuchenie {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 25px;
            padding-bottom: 0px;
            margin-bottom: -20px
        }

        .obuchenie h2 {
            font-size: 33px;
        }

        .bluekrug {
            float: left;
            margin-right: 10px;
            margin-bottom: 40px;
        }

        .sm-video, .last-stav {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .sm-video h2 {
            font-size: 30px;
        }

        .sertifikat {
            background: none;
            padding-left: 0px;
        }

        .vidos {
            height: 280px;
        }
      .iba {font-size: 29px !important;}
      .rezults {margin: 10px auto; min-height: auto;}

        .last-stav {
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
            padding-bottom: 0px;
        }
    }
    @media (max-width: 420px) {
      .vidok {height: 220px;}
    }

</style>
